import { Route } from 'react-router-dom';
import WhatsApp from './WhatsApp';

const WhatsAppRouter = (
  <Route path="whatsapp">
    <Route path="" element={<WhatsApp />} />
  </Route>
);

export default WhatsAppRouter;
